import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const DemandFilters = ({ filters, onFilterChange, clients }) => {
  const handleFilterChange = (key, value) => {
    onFilterChange({
      ...filters,
      [key]: value
    });
  };

  const handleClearFilters = () => {
    onFilterChange({
      status: 'all',
      client: 'all',
      priority: 'all',
      dateRange: 'all'
    });
  };

  const hasActiveFilters = filters?.status !== 'all' || 
                           filters?.client !== 'all' || 
                           filters?.priority !== 'all' || 
                           filters?.dateRange !== 'all';

  return (
    <div className="bg-card rounded-lg border border-border p-4 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 flex-1">
          {/* Status Filter */}
          <div>
            <label className="text-xs text-muted-foreground mb-1 block">
              Status
            </label>
            <Select
              value={filters?.status}
              onValueChange={(value) => handleFilterChange('status', value)}
            >
              <option value="all">Todos</option>
              <option value="Pendente">Pendente</option>
              <option value="Em Análise">Em Análise</option>
              <option value="Aprovado">Aprovado</option>
              <option value="Rejeitado">Rejeitado</option>
            </Select>
          </div>

          {/* Client Filter */}
          <div>
            <label className="text-xs text-muted-foreground mb-1 block">
              Cliente
            </label>
            <Select
              value={filters?.client}
              onValueChange={(value) => handleFilterChange('client', value)}
            >
              <option value="all">Todos os Clientes</option>
              {clients?.map((client, index) => (
                <option key={index} value={client}>
                  {client}
                </option>
              ))}
            </Select>
          </div>

          {/* Priority Filter */}
          <div>
            <label className="text-xs text-muted-foreground mb-1 block">
              Prioridade
            </label>
            <Select
              value={filters?.priority}
              onValueChange={(value) => handleFilterChange('priority', value)}
            >
              <option value="all">Todas</option>
              <option value="Crítica">Crítica</option>
              <option value="Alta">Alta</option>
              <option value="Média">Média</option>
              <option value="Baixa">Baixa</option>
            </Select>
          </div>

          {/* Date Range Filter */}
          <div>
            <label className="text-xs text-muted-foreground mb-1 block">
              Período
            </label>
            <Select
              value={filters?.dateRange}
              onValueChange={(value) => handleFilterChange('dateRange', value)}
            >
              <option value="all">Todo o Período</option>
              <option value="today">Hoje</option>
              <option value="week">Esta Semana</option>
              <option value="month">Este Mês</option>
              <option value="quarter">Este Trimestre</option>
            </Select>
          </div>
        </div>

        {/* Clear Filters Button */}
        {hasActiveFilters && (
          <Button
            variant="outline"
            iconName="X"
            iconPosition="left"
            onClick={handleClearFilters}
          >
            Limpar Filtros
          </Button>
        )}
      </div>
    </div>
  );
};

export default DemandFilters;